import { BottomModal, Button, Card, FlexColumn, SeparatorLine, SushiModal, VerticalLine } from "../Common/styles.common";
import React from "react";
import SafeHtml from "components/shared/helpers/SafeHtml";
import { CardWrapper, DisputeRaisedInfoBox } from "./styles.grn";
import GenerateCN from "./generateCN";
import { strings } from "utils/constants/strings";
import Cross from "sushiweb/Icons/all/Cross";
import Spinner from "sushiweb/Spinner/Spinner";
import ShowToast from "../Common/Toast";
import Input from "components/shared/InputTypes/Input";

const GrnDetailsModals = ({
 grnId, grn, generateCn, po, openDiscrepancyReasonModal, showButtonLoader, discrepancyItem, showToast, errorMsg, openGrnConfirmedModal, showInvoiceNumberModal, setShowInvoiceNumberModal, overriddenInvoiceNumber, showPopup, paymentOptionsModal, paymentOptions, selectedPaymentOption, openDisputeRaisedModal, setOpenDisputeRaisedModal, grnSummary, popupText, closeConfirmGrnModal, togglePopupModel, HandleSellerStatusUpdate, handleCNCreationEvent, handleCNCreationFailureEvent, toggleDiscrepancyModal, generateInvoiceCTA, openConfirmationModal, setOpenConfirmationModal, handleInvoiceNumberChange, handlePaymentOptionSelect,
}) => (
  <React.Fragment>
      {showInvoiceNumberModal && (
        <>
          <SushiModal
            title={strings.grnModalEnterInvoiceNumber}
            visible={showInvoiceNumberModal}
            isCentered
            showCloseIcon={true}
            onClose={() => setShowInvoiceNumberModal(false)}
          >
            <FlexColumn className="align-items-center invoice-modal w-full">
              <span className="wd-100">
                <Input
                  type="text"
                  placeholder={strings.grnModalInvoiceNumberPlaceholder}
                  value={overriddenInvoiceNumber}
                  onChange={(value) => handleInvoiceNumberChange(value)}
                  className="w-full  border-redius-12   input-class"
                />
                {" "}
              </span>
              <Button
                className="fs-13 text-white fw-600 border-redius-12"
                onClick={generateInvoiceCTA}
              >
                {strings.grnModalClickToGenerateInvoice}
              </Button>
            </FlexColumn>
          </SushiModal>
          <SushiModal visible={showPopup} isCentered>
            <FlexColumn className="align-items-center p-5">
              <img src={"/logos/info_logo.svg"} height="80px" width="80px" />
              <span className="fs-22 fw-700 my-4">{popupText}</span>
              <span
                className="fs-14 fw-500 text-red-500"
                onClick={togglePopupModel}
              >
                {" "}
                {strings.grnModalOkay}
              </span>
            </FlexColumn>
          </SushiModal>
        </>
      )}
      {generateCn && (
        <GenerateCN
          handleCNCreationEvent={handleCNCreationEvent}
          handleCNCreationFailureEvent={handleCNCreationFailureEvent}
          grnId={grnId}
        />
      )}
      <BottomModal
        visible={openDiscrepancyReasonModal}
        onClose={toggleDiscrepancyModal}
        showCloseIcon={true}
      >
        <FlexColumn className="align-items-center p-4">
          <Cross
            color={"#696969"}
            className="close"
            onClick={toggleDiscrepancyModal}
          />
          <img
            src={discrepancyItem?.product_image}
            height="80px"
            width="80px"
            className="mt-2"
          />
          <span className="fs-20 fw-700 mt-4">
            {discrepancyItem?.product_name}
          </span>
          <span className="fs-16 fw-400 text-gray-cool mt-2">
            &#8377;{discrepancyItem?.po_item_price_per_unit}
          </span>
          <Card className="wd-100 align-items-center mt-5 mb-4 mx-4">
            <div className="d-flex wd-100 justify-content-center">
              <FlexColumn className="wd-50 align-items-center">
                <span className="fs-15 fw-700">
                  {discrepancyItem?.invoiced_quantity}{" "}
                  {discrepancyItem?.buy_measurement_unit}
                </span>
                <span className="fs-13 fw-400 text-gray-cool mt-2">
                  {strings.invoicedQty}
                </span>
              </FlexColumn>
              <VerticalLine />
              <FlexColumn className="wd-50 align-items-center">
                <span className="fs-15 fw-700">
                  {discrepancyItem?.grn_quantity}{" "}
                  {discrepancyItem?.buy_measurement_unit}
                </span>
                <span className="fs-13 fw-400 text-gray-cool mt-2">
                  {strings.grnModalGrnQtyLabel}
                </span>
              </FlexColumn>
            </div>
          </Card>
          <Card className="wd-100 mb-3 p-4">
            <span className="fs-16 fw-700">{strings.grnModalDiscrepancyReasons}</span>
            <SeparatorLine />
            {discrepancyItem?.discrepancy_qty_reasons ? (
              discrepancyItem.discrepancy_qty_reasons.map((reason, index) => (
                <div className="d-flex justify-content-between mb-4">
                  <span className="fs-14 fw-400">{reason.reason}</span>
                  <span className="fs-14 fw-500">
                    {reason.quantity} {discrepancyItem?.buy_measurement_unit}
                  </span>
                </div>
              ))
            ) : (
              <></>
            )}
          </Card>
        </FlexColumn>
      </BottomModal>
      <SushiModal visible={openConfirmationModal} isCentered>
        <FlexColumn className="align-items-center p-5">
          <img src="/logos/info_logo.svg" height="80px" width="80px" />
          <span className="fs-21 fw-700 my-4 text-align-center">
            {grn?.cn_data?.total_cn_amount !== 0
              ? strings.confirmationGrnAndCNModal
              : grn?.dn_data?.total_dn_amount !== 0
                ? strings.confirmationGrnAndDNModal
                : strings.confirmationGrnModal}
          </span>
          {grn?.cn_data?.total_cn_amount === 0 &&
            grn?.dn_data?.total_dn_amount === 0 ? (
            selectedPaymentOption ? (
              <CardWrapper
                showBorder={true}
                bgColor={"#F8F9FC"}
                className="d-flex flex-column align-items-center wd-100 mb-4 p-4"
              >
                <>
                  <span className="fs-18 fw-600 green-color">
                    &#8377; {selectedPaymentOption.net_payout?.toLocaleString("en-IN")}
                  </span>
                  <span className="fs-14 fw-400 text-gray-cool mt-2 my-3">
                    {selectedPaymentOption.payment_type === "DISCOUNTED"
                      ? `will be paid on ${selectedPaymentOption.payment_date_str}`
                      : strings.grnModalWillBePaidToYou}
                  </span>
                  {selectedPaymentOption.discount > 0 && (
                    <>
                      <div className="dotted-line"></div>
                      <div className="cn-table-class">
                        <span className="fs-14 fw-400 text-gray-cool mt-2">
                           {strings.grnModalOriginalAmount}
                        </span>
                        <span className="fs-14 fw-600 ml-6">
                          + &#8377; {selectedPaymentOption.original_payout?.toLocaleString("en-IN")}
                        </span>
                      </div>
                      <div className="cn-table-class">
                        <span className="fs-14 fw-400 text-gray-cool mt-2">
                          {strings.grnModalDiscount} ({selectedPaymentOption.discount_percentage}%)
                        </span>
                        <span className="fs-14 fw-600 ml-6" style={{ color: "#FF6B6B" }}>
                          - ₹ {selectedPaymentOption.discount?.toLocaleString("en-IN")}
                        </span>
                      </div>
                      <div className="dotted-line"></div>
                      <div className="cn-table-class">
                        <span className="fs-14 fw-400 text-gray-cool mt-2">
                          {strings.grnModalNetPayout}
                        </span>
                        <span className="fs-14 fw-600 ml-6">
                          &#8377; {selectedPaymentOption.net_payout?.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </>
                  )}
                </>
              </CardWrapper>
            ) : (
              <CardWrapper
                showBorder={true}
                bgColor={"#F8F9FC"}
                className="d-flex flex-column align-items-center wd-100 mb-4 p-4"
              >
                <span className="fs-18 fw-600">
                  &#8377; {grn.grn_amount?.toLocaleString("en-IN")}
                </span>
                <span className="fs-14 fw-400 text-gray-cool mt-2">
                   {strings.grnModalWillBePaidToYou}
                </span>
              </CardWrapper>
            )
          ) : grn?.cn_data?.total_cn_amount === 0 ? (
            <CardWrapper
              showBorder={true}
              bgColor={"#F8F9FC"}
              className="d-flex flex-column align-items-center wd-100 mb-4 p-4"
            >
              <>
                <span className="fs-18 fw-600 green-color">
                  &#8377;{" "}
                  {(
                    grn.grn_amount - grn?.dn_data?.total_dn_amount
                  ).toLocaleString("en-IN")}
                </span>
                <span className="fs-14 fw-400 text-gray-cool mt-2 my-3">
                  {strings.grnModalWillBePaidToYou}
               </span>
               <div className="dotted-line"></div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2">
                   {strings.grnModalGrnAmountLabel}
                 </span>
                 <span className="fs-14 fw-600 ml-6">
                   + &#8377; {grn.grn_amount?.toLocaleString("en-IN")}
                 </span>
               </div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2 ">
                   {strings.grnModalCnAmountLabel}
                 </span>
                 <span className="fs-14 fw-600 ml-6">
                   - &#8377;{" "}
                   {grn?.dn_data?.total_dn_amount?.toLocaleString("en-IN")}
                 </span>
               </div>
               <div className="dotted-line"></div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2">
                   {strings.grnModalTotalAmountLabel}
                 </span>
                  <span className="fs-14 fw-600 ml-6">
                    &#8377;{" "}
                    {(
                      grn.grn_amount - grn?.dn_data?.total_dn_amount
                    ).toLocaleString("en-IN")}
                  </span>
                </div>
              </>
            </CardWrapper>
          ) : (
            <CardWrapper
              showBorder={true}
              bgColor={"#F8F9FC"}
              className="d-flex flex-column align-items-center wd-100 mb-4 p-4"
            >
              <>
                <span className="fs-18 fw-600 green-color">
                  &#8377;{" "}
                  {(
                    grn.grn_amount - grn?.cn_data?.total_cn_amount
                  ).toLocaleString("en-IN")}
                </span>
                <span className="fs-14 fw-400 text-gray-cool mt-2 my-3">
                  {strings.grnModalWillBePaidToYou}
               </span>
               <div className="dotted-line"></div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2">
                   {strings.grnModalGrnAmountLabel}
                 </span>
                 <span className="fs-14 fw-600 ml-6">
                   + &#8377; {grn.grn_amount?.toLocaleString("en-IN")}
                 </span>
               </div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2 ">
                   {strings.grnModalCnAmountLabel}
                 </span>
                 <span className="fs-14 fw-600 ml-6">
                   - &#8377;{" "}
                   {grn?.cn_data?.total_cn_amount?.toLocaleString("en-IN")}
                 </span>
               </div>
               <div className="dotted-line"></div>
               <div className="cn-table-class">
                 <span className="fs-14 fw-400 text-gray-cool mt-2">
                   {strings.grnModalTotalAmountLabel}
                 </span>
                  <span className="fs-14 fw-600 ml-6">
                    &#8377;{" "}
                    {(
                      grn.grn_amount - grn?.cn_data?.total_cn_amount
                    ).toLocaleString("en-IN")}
                  </span>
                </div>
              </>
            </CardWrapper>
          )}
          <Button
            className="fs-13 text-white fw-600 mb-3"
            onClick={() => HandleSellerStatusUpdate(grn.id, po.id)}
            disabled={showButtonLoader}
          >
            {showButtonLoader ? <Spinner color={"white"} /> : strings.grnModalYesConfirm}
          </Button>
          <span
            className="fs-14 fw-500 text-red-500"
            onClick={() => setOpenConfirmationModal(false)}
          >
            {strings.grnModalNoGoBack}
          </span>
        </FlexColumn>
      </SushiModal>
      <SushiModal visible={paymentOptionsModal} isCentered>
        {(() => {
          const discountedOption = paymentOptions.find((o) => o.payment_type === "DISCOUNTED");
          const defaultOption = paymentOptions.find((o) => o.payment_type === "DEFAULT");
          return (
            <FlexColumn className="align-items-center p-5">
              <img src="/logos/info_logo.svg" height="80px" width="80px" />
              <span className="fs-21 fw-700 my-4 text-align-center">
                {strings.grnModalGetPaidEarly}
              </span>
              <CardWrapper
                showBorder={true}
                bgColor={"#F8F9FC"}
                className="d-flex flex-column wd-100 mb-4 p-4"
              >
                <span className="fs-22 fw-700 green-color text-align-center">
                  &#8377; {discountedOption?.net_payout?.toLocaleString("en-IN")}
                </span>
                <span className="fs-13 fw-400 text-gray-cool text-align-center mt-1 mb-3">
                  {strings.grnModalWillBePaidOnApproval}
                </span>
                <div className="dotted-line"></div>
                <div className="cn-table-class mt-3">
                  <span className="fs-14 fw-400 text-gray-cool">{strings.grnModalPayableAmount}</span>
                  <span className="fs-14 fw-600">
                    + &#8377; {discountedOption?.original_payout?.toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="cn-table-class mt-2">
                  <span className="fs-14 fw-400 text-gray-cool">
                    {strings.grnModalEarlyPaymentDisc} ({discountedOption?.discount_percentage}%)
                  </span>
                  <span className="fs-14 fw-600" style={{ color: "#FF6B6B" }}>
                    - &#8377; {discountedOption?.discount?.toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="dotted-line mt-3"></div>
                <div className="cn-table-class mt-3">
                  <span className="fs-14 fw-600">{strings.grnModalPaymentAmount}</span>
                  <span className="fs-14 fw-700">
                    &#8377; {discountedOption?.net_payout?.toLocaleString("en-IN")}
                  </span>
                </div>
              </CardWrapper>
              <Button
                className="fs-14 text-white fw-600 mb-3"
                onClick={() => handlePaymentOptionSelect(discountedOption)}
              >
                Get paid on {discountedOption?.payment_date_str} with discount
              </Button>
              <span
                className="fs-14 fw-500 text-red-500"
                onClick={() => handlePaymentOptionSelect(defaultOption)}
              >
                Wait for full payment on {defaultOption?.payment_date_str}
              </span>
            </FlexColumn>
          );
        })()}
      </SushiModal>
      <SushiModal visible={openGrnConfirmedModal} isCentered>
        <FlexColumn className="align-items-center p-5">
          <img src="/logos/tick_logo.svg" height="80px" width="80px" />
          {selectedPaymentOption && grn?.cn_data?.total_cn_amount === 0 && grn?.dn_data?.total_dn_amount === 0 ? (
            <span className="fs-22 fw-700 my-4 text-align-center">
              You will receive {" "}
              <span className="green-color">
                &#8377;{selectedPaymentOption?.net_payout?.toLocaleString("en-IN")}
              </span>{" "}
              payment on <span className="text-red-500">{selectedPaymentOption?.payment_date_str}</span>.
            </span>
          ) : (
            <span className="fs-22 fw-700 my-4 text-align-center">
              {strings.grnModalGrnConfirmed}
            </span>
          )}
          <span
            className="fs-14 fw-500 text-red-500"
            onClick={closeConfirmGrnModal}
          >
            {" "}
            {strings.grnModalOkay}
          </span>
        </FlexColumn>
      </SushiModal>

      <SushiModal visible={openDisputeRaisedModal} isCentered>
        <FlexColumn className="align-items-center p-5">
          <img src="/logos/tick_logo.svg" height="80px" width="80px" />
          <span className="fs-22 fw-700 my-4 text-align-center">
            {strings.grnModalDisputeRaised}
          </span>
          {grnSummary?.info_label?.text && (
            <DisputeRaisedInfoBox>
              <SafeHtml
                tag="span"
                style={{ color: "#293142", lineHeight: "1.5", fontSize: "14px", fontWeight: "400" }}
                html={grnSummary.info_label.text}
              />
            </DisputeRaisedInfoBox>
          )}
          <span
            className="fs-14 fw-500 text-red-500"
            style={{ marginTop: "16px" }}
            onClick={() => setOpenDisputeRaisedModal(false)}
          >
            {strings.grnModalOkay}
          </span>
        </FlexColumn>
      </SushiModal>

      {showToast ? <ShowToast errorMsg={errorMsg} /> : <></>}
  </React.Fragment>
);

export default GrnDetailsModals;
